// Shared max-width + padding so the navbar and every section's content
// line up on the same left/right edges at every breakpoint.
export const CONTAINER = 'mx-auto w-full max-w-5xl px-6 sm:px-8';
